import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL?.replace('/api', '') || 'http://127.0.0.1:8000';

// Load current user from localStorage (deprecated - use AuthContext instead)
const loadCurrentUser = () => {
  try {
    const stored = localStorage.getItem('currentUser');
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error('Error loading current user:', error);
  }
  // No default user - should use AuthContext for current user
  return null;
};

// Save current user to localStorage
const saveCurrentUser = (user) => {
  try {
    localStorage.setItem('currentUser', JSON.stringify(user));
  } catch (error) {
    console.error('Error saving current user:', error);
  }
};

// Async thunks
export const fetchAllUsers = createAsyncThunk(
  'user/fetchAllUsers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/users/all`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || 'Failed to fetch users');
    }
  }
);

export const switchUser = createAsyncThunk(
  'user/switchUser',
  async (username, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/users/switch`, { username });
      return response.data.user;
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || 'Failed to switch user');
    }
  }
);

const userSlice = createSlice({
  name: 'user',
  initialState: {
    currentUser: loadCurrentUser(),
    allUsers: [],
    loading: false,
    error: null
  },
  reducers: {
    setCurrentUser: (state, action) => {
      state.currentUser = action.payload;
      saveCurrentUser(action.payload);
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch all users
      .addCase(fetchAllUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.allUsers = action.payload;
      })
      .addCase(fetchAllUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Switch user
      .addCase(switchUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(switchUser.fulfilled, (state, action) => {
        state.loading = false;
        state.currentUser = action.payload;
        saveCurrentUser(action.payload);
      })
      .addCase(switchUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setCurrentUser, clearError } = userSlice.actions;
export default userSlice.reducer;
